import React, { useEffect } from "react";
// import { LargeBodyText } from '../../shared/text/Text';
import referlist from "referlist";
import styled from "styled-components";

import Subtitle from "../../components/shared/text/Subtitle";
import { LargeBodyText } from "../../components/shared/text/Text";
import { smMedia } from "../../utils/getMediaStyle";
import Button from "../Button";
import Input from "../Input";

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${({ theme }) => theme.color.background.contentBreaker};
  ${smMedia`
    width: 100vw;
    overflow:hidden;
  `}
`;

const Signup = (props) => {
  useEffect(() => {
    referlist.initialize({
      domain: "copysmith",
      emailId: "referlistemail2",
      buttonId: "referlistbutton2",
    }); // this will setup the second field
  }, []);
  return (
    <Container className="d-flex flex-column p-4 p-md-5" {...props}>
      <Subtitle size={60} smSize={28} className="text-center">
        1 step content marketing
      </Subtitle>
      <LargeBodyText className="mt-3">
        Sign up to be notified about when we move out of our invite-only beta.
      </LargeBodyText>
      <div className="d-flex w-100 mt-4 flex-column flex-md-row align-items-center justify-content-center">
        <div className="col-12 col-md-4 pl-0 mb-4 mb-md-0">
          <Input
            type="text"
            id="referlistemail2"
            placeholder="Enter email"
            className="mr-5"
          />
        </div>

        <Button id="referlistbutton2" className="col-6 col-md-2">
          Join waitlist
        </Button>
        <br />
        <br />
        <br />
      </div>
    </Container>
  );
};

export default Signup;
